import { Flex, Input, Text } from '@chakra-ui/react';
import useUpdateField from './useUpdateField';

const InputOption = ({ label, field, path }) => {
  const [state, setState] = useUpdateField(field, path);

  return (
    <Flex my="1">
      <Text w="90px" flexShrink="0">{label}</Text>
      <Input value={state} onChange={(e) => setState(e.target.value)} />
    </Flex>
  );
};

export default InputOption;
